import { Progress } from '../ui/progress';

export const ProgressCard = ({ currentWeek, totalWeeks }) => {
  const percent = (currentWeek / totalWeeks) * 100;
  return (
    <div className="bg-primary p-6" data-testid="program-progress-card">
      <h3 className="font-heading text-xl text-primary-foreground uppercase tracking-wider mb-4">Your Progress</h3>
      <div className="text-center mb-4">
        <p className="font-heading text-5xl text-primary-foreground">{currentWeek}</p>
        <p className="text-primary-foreground/70">of {totalWeeks} weeks</p>
      </div>
      <Progress value={percent} className="h-3 bg-black/20" />
      <p className="text-primary-foreground/70 text-sm text-center mt-2">{Math.round(percent)}% Complete</p>
    </div>
  );
};
